import { ICartProduct, IOrder, IShipmentPayment } from '@/store/ducks/order/types';

export const usePurchaseEvent = (order: IOrder | undefined, payment: IShipmentPayment) => {
  if (!window.gtag || !order?.cart.products.length) return;

  localStorage.setItem('last_paid_order', JSON.stringify(order.id));
  window.gtag('event', 'purchase', {
    currency: 'BRL',
    value: order.cart.items_total,
    transaction_id: payment.nsu?.toString() || '',
    items: order.cart.products.map((product: ICartProduct) => {
      return {
        item_id: product.product_id,
        item_name: product.title,
      };
    }),
  });
};
